(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'User', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants', 'JhiLanguageService','AnagraficaService','SessionStorage'];

    function UserManagementController(Principal, User, ParseLinks, AlertService, $state, pagingParams, paginationConstants, JhiLanguageService,AnagraficaService,SessionStorage) {
        var vm = this;

        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.users = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;
        
        SessionStorage.init(vm, "UR1L.strutturati", ["nameFilter", "profileFilter"]);
        
        vm.loadAll();
        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function loadAll () {
        	if(vm.nameFilter==="")
        		vm.nameFilter = null;
        	if(vm.profileFilter==="")
        		vm.profileFilter = null;
        	
        	SessionStorage.saveAll(vm, "UR1L.strutturati", ["nameFilter", "profileFilter"]);
        	
        	AnagraficaService.strutturati.get({
        		page: pagingParams.page - 1,
        		size: vm.itemsPerPage,
        		sort: sort(),
        		filterName: vm.nameFilter
        	}, onSuccess, onError);

        }

        function onSuccess(data, headers) {
        	var filter = headers('FILTER-filterName');
        	if (filter == vm.nameFilter || (!filter && vm.nameFilter == '') ) {
        		console.log("showing results filtered for: " + filter);
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.page = pagingParams.page;
                vm.users = data;
        	} else {
        		console.log("filtering response not corresponding to actual query");
        	}
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
        	if(vm.nameFilter==="")
        		vm.nameFilter = null;
        	if(vm.profileFilter==="")
        		vm.profileFilter = null;
        	
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                filterName: vm.nameFilter,
                filterRole: vm.profileFilter
            });
        }
    }
})();
